import { render } from "./OptionView.vue?vue&type=template&id=454104b0&scoped=true"
import script from "./OptionView.vue?vue&type=script&lang=js"
export * from "./OptionView.vue?vue&type=script&lang=js"

import "./OptionView.vue?vue&type=style&index=0&id=454104b0&lang=scss&scoped=true"

import exportComponent from "/home/ak/projects/ysm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-454104b0"]])

export default __exports__